import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';
import { Label } from 'src/app/shared/framework/labels/models/Label';
import { Observable, of } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';

@Pipe({
  name: 'label',
})
export class LabelPipe implements PipeTransform {

  constructor(private labelService: LabelService) { }

  transform(
    value: string,
    context?: string,
    showLabelKey: boolean = false
  ): Observable<string> {

    if (!value) {
      return of('');
    }

    const key = value.toLowerCase();
    const ctx = context?.toLowerCase() ?? this.labelService.getContextName();

    return this.labelService.getContext(ctx).pipe(
      map(labelContext => {
        let labelText = `<<< LABEL ${ctx}:${key} >>>`;

        if (labelContext) {
          const label = labelContext.get(key);
          if (label?.labelText) {
            labelText = label.labelText;
          }
        } else {
          console.error(`No label context for ${ctx}`);
        }

        return showLabelKey
          ? `<<< ${ctx}:${key}: ${labelText} >>>`
          : labelText;
      })
    );
  }
}